export default function SectionHeader({ title, subtitle }) {
  return (
    <div className="text-center mb-6">
      <h2 className="text-4xl font-bold text-emerald-100 mb-4">{title}</h2>
      <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-green-600 mx-auto mb-6"></div>
      {subtitle && (
        <p className="text-gray-300/80 text-lg">{subtitle}</p>
      )}
    </div>
  );
}